import { SpecialIcon as ButtonIcon } from '@/component/Buttons/SpecialIcon/SpecialIcon';
import { MinusIcon } from '@/component/Icons/MinusIcon';
import { PlusIcon } from '@/component/Icons/PlusIcon';
import styles from './Counter.module.css';

export function Counter({
  value,
  title,
  subtext,
  onIncrement,
  onDecrement,
  decrementDisabled,
}) {
  return (
    <div className={styles.counter}>
      <div>
        <div className={styles.counter__title}>{title}</div>
        <div className={styles.counter__subtext}>{subtext}</div>
      </div>
      <div className={styles.counter__controls}>
        <ButtonIcon onClick={onDecrement} disabled={decrementDisabled}>
          <MinusIcon />
        </ButtonIcon>
        <span className={styles.counter__value}>{value}</span>
        <ButtonIcon onClick={onIncrement}>
          <PlusIcon />
        </ButtonIcon>
      </div>
    </div>
  );
}
